const getSelectedVariant = (product_json) => {
  const selectedOptions = {};

  // Find the form with the specific action attribute
  const form = document.querySelector('form[action^="/cart/add"]');
  if (!form) return null;

  // Find all elements with the data-custom-option-selector attribute within the form
  const options = form.querySelectorAll('[data-custom-option-selector]');
  options.forEach((option) => {
    const optionName = option.getAttribute('data-custom-option-selector');
    const selectedValElement = option.querySelector('.ProductOption__variant--selected');

    // Safeguard against missing elements
    const selectedVal = selectedValElement ? selectedValElement.getAttribute('data-value') : null;
    // if (selectedVal !== null) {
    selectedOptions[optionName] = selectedVal;
    // }
  });

  const { option1: selectedColor, option2: selectedSize } = selectedOptions;

  // Find the variant that matches the selected options
  for (let i = 0; i < product_json.variants.length; i++) {
    const variant = product_json.variants[i];

    if (variant.option1 === selectedColor) {
      if (variant.option2 === selectedSize) {
        return variant; // Return the exact match if found
      }
    }
  }

  // If no exact match is found, return the first available size for the selected color
  for (let i = 0; i < product_json.variants.length; i++) {
    const variant = product_json.variants[i];

    if (variant.option1 === selectedColor && variant.available) {
      return variant; // Return the first available variant with the selected color
    }
  }

  return null;
};

export default getSelectedVariant;
